const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/capacity/holiday-scheme/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import i18next from 'i18next';
import { capacitySearchSchema } from '@/features/settings/capacity/searchSchema';
export const Route = createFileRoute('/(app)/org/$org/settings/capacity/holiday-scheme/')({
  validateSearch: zodValidator(capacitySearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: (): LoaderData => ({
    crumb: i18next.t($ => $.common.settings.capacity.capacity)
  }),
  staticData: {
    topNav: {
      title: i18next.t($ => $.common.settings.capacity.capacity)
    }
  }
});